import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NGXLogger } from 'ngx-logger';
import { catchError, map, of, switchMap, tap } from 'rxjs';

import { cashSettlementAction } from './cash-settlement.actions';
import { CashSettlementDraftErrorCode } from '../models/cash-settlement-create.model';
import { CashSettlementService } from '../service/cash-settlement.service';

@Injectable()
export class CashSettlementEffects {
  constructor(
    private actions$: Actions,
    private logger: NGXLogger,
    private cashSettlementService: CashSettlementService
  ) {}

  cashSettlementListRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(cashSettlementAction.cashSettlementListRequest),
      tap((_) => this.logger.debug('@Effect [Cash Settlement] cash settlement list request ')),
      switchMap(({ payload }) => {
        return this.cashSettlementService.list({ ...payload }).pipe(
          map((response) => {
            return cashSettlementAction.cashSettlementListResponse({ response });
          }),
          catchError((err) => of(err))
        );
      })
    );
  });

  cashSettlementDetailRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(cashSettlementAction.viewCashSettlementRequest),
      tap((_) => this.logger.debug('@Effect [Cash Settlement] cash settlement detail request ')),
      switchMap((payload) => {
        return this.cashSettlementService.detail(payload.cashSettlementNo).pipe(
          map((response) => {
            return cashSettlementAction.viewCashSettlementResponse({ response });
          }),
          catchError((err) => of(err))
        );
      })
    );
  });

  cashSettlementCreateDraftRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(cashSettlementAction.cashSettlementCreateDraftRequest),
      tap((_) => this.logger.debug('@Effect [Cash Settlement] cash settlement create draft request ')),
      switchMap(() => {
        return this.cashSettlementService.draft().pipe(
          map((response) => {
            return cashSettlementAction.cashSettlementCreateDraftResponse({ response });
          }),
          catchError((error) => {
            if (CashSettlementDraftErrorCode.includes(error.code)) {
              return of(cashSettlementAction.cashSettlementCreateDraftResponse({ response: error }));
            }
            console.error('Unhandled error:', error);
            return of(cashSettlementAction.cashSettlementCreateDraftResponse({ response: error }));
          })
        );
      })
    );
  });

  cashSettlementSubmitDraftRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(cashSettlementAction.cashSettlementSubmitDraftRequest),
      tap((_) => this.logger.debug('@Effect [Cash Settlement] cash settlement submit draft request ')),
      switchMap(({ payload }) => {
        return this.cashSettlementService.submit({ ...payload }).pipe(
          map((response) => {
            return cashSettlementAction.cashSettlementSubmitDraftResponse({ response });
          }),
          catchError((error) => {
            if (CashSettlementDraftErrorCode.includes(error.code)) {
              return of(cashSettlementAction.cashSettlementSubmitDraftResponse({ response: error }));
            }
            console.error('Unhandled error:', error);
            return of(cashSettlementAction.cashSettlementSubmitDraftResponse({ response: error }));
          })
        );
      })
    );
  });

  cashSettlementSubmitTransferEvidenceRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(cashSettlementAction.cashSettlementSubmitTransferEvidenceRequest),
      tap((_) => this.logger.debug('@Effect [Cash Settlement] cash settlement submit transfer evidence request ')),
      switchMap(({ payload }) => {
        return this.cashSettlementService.submitTransferEvidence({ ...payload }).pipe(
          map((response) => {
            return cashSettlementAction.cashSettlementSubmitTransferEvidenceResponse({ response });
          }),
          catchError((error) => {
            if (CashSettlementDraftErrorCode.includes(error.code)) {
              return of(cashSettlementAction.cashSettlementSubmitTransferEvidenceResponse({ response: error }));
            }
            console.error('Unhandled error:', error);
            return of(cashSettlementAction.cashSettlementSubmitTransferEvidenceResponse({ response: error }));
          })
        );
      })
    );
  });
}
